import { addNamespace } from '@muz/jobboard-vue-client/src/store/helper/namespace';
import { merge } from 'lodash';
import LoaderTypes from './mixins/Loader';

const namespace = 'JobAd';

const Types = merge(
    {
        mutations: {
            SET_SCORE: 'setScore',
            SET_HIGHLIGHTS: 'setHighlights',
            SET_SANITIZED_TEXT: 'setSanitizedText',
            SET_TITLE: 'setTitle',
            SET_DATA: 'setData',
        },
        actions: {
            LOAD_JOB_AD: 'loadJobAd',
            LOAD_CUSTOM_JOB_AD: 'loadCustomJobAd',
        },
    },
    LoaderTypes,
);

export const LocalTypes = {
    ...Types,
    namespace,
};

export default {
    ...addNamespace(namespace, Types),
    namespace,
};
